const eventsList = {
    USER_RIGHTS_UPDATED: "USER_RIGHTS_UPDATED",
    LOGOUT: "LOGOUT"
};

export default eventsList;
